import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import HighLightSimpanPage from 'containers/pages/webManagement/highlightSimpan/List'
import HighLightSimpanForm from 'containers/pages/webManagement/highlightSimpan/Form'

const HighLightSimpan = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/web-management/highlight-simpan') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementhighlight-simpan-read') > -1) {
      return <HighLightSimpanPage location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementhighlight-simpan-write') > -1) {
      return <HighLightSimpanForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

HighLightSimpan.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default HighLightSimpan
